'use client'

import Image from 'next/image'
import type { PortableTextBlock } from '@portabletext/types'
import styles from './NewsletterSignUpSection.module.scss'
import RichText from '@/components/RichText/RichText'
import NewsletterForm from './NewsletterForm'
import { headerSerializer, subtitleSerializer } from './serializers'
import useBreakpoint from '@/hooks/use-breakpoint'

interface NewsletterSignUpSectionContent {
  header: PortableTextBlock[]
  subtitle: PortableTextBlock[]
  eyebrow?: string
  successMessage?: {
    title: PortableTextBlock[]
    subtitle: PortableTextBlock[]
  }
}

interface NewsletterSignUpSectionProps {
  content: NewsletterSignUpSectionContent
  sectionBackground: SectionBackground
}

const NewsletterSignUpSection = ({ content, sectionBackground }: NewsletterSignUpSectionProps) => {
  const { eyebrow, header, subtitle, successMessage } = content || {}
  const { isMobile } = useBreakpoint()

  if (!content) return null

  return (
    <section
      className={styles.newsletterSection}
      style={{ backgroundColor: sectionBackground === 'dough' ? 'var(--dough)' : undefined }}
    >
      <div className={styles.container}>
        <div className={styles.content}>
          {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}

          {header && header.length > 0 && (
            <RichText
              value={header}
              components={headerSerializer}
            />
          )}

          {subtitle && (
            <RichText
              value={subtitle}
              components={subtitleSerializer}
            />
          )}
        </div>

        <div className={styles.form}>
          <NewsletterForm successMessage={successMessage} />
        </div>

        {/* Bao Bao Image */}
        <div className={styles.baoBaoImageSection}>
          <div className={styles.baoBaoImageWrapper}>
            <Image
              src={isMobile ? '/images/baobao-with-wte.png' : '/images/baobao-without-wte.png'}
              alt="Bao Bao"
              width={isMobile ? 184 : 437}
              height={isMobile ? 173 : 411}
              priority
            />
          </div>
        </div>
      </div>
    </section>
  )
}

NewsletterSignUpSection.displayName = 'NewsletterSignUpSection'

export default NewsletterSignUpSection
